export const readableCampaignTest = /^[a-zA-Z0-9_-]+$/;
